const PatientImages = () =>
    import ("@/components/dashboard/patient/Images");
const PatientGalleryAudios = () =>
    import ("@/components/dashboard/patient/Audios");
const PatientGalleryVideos = () =>
    import ("@/components/dashboard/patient/Videos");
const PatientGalleryPDFs = () =>
    import ("@/components/dashboard/patient/Pdf");

export default [{
        path: "certificates",
        name: "dashboard.patient.records.certificates"
            // component: PatientGalleryImages
    },
    {
        path: "consents",
        name: "dashboard.patient.records.consents"
            // component: PatientGalleryAudios
    },
    {
        path: "cards",
        name: "dashboard.patient.records.cards"
            // component: PatientGalleryVideos
    },
    {
        path: "documents",
        name: "dashboard.patient.records.documents",
        component: PatientImages
    },

];